// src/features/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthUser } from "../../../Constants/Interfaces";

interface initialStateType {
  user: AuthUser | null;
  isLoggedIn: boolean;
}

const initialState: initialStateType = {
  user: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: AuthUser; isLoggedIn: boolean }>
    ) => {
      state.user = action.payload.user;
      state.isLoggedIn = action.payload.isLoggedIn;
    },
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
